<template>
  <a-card :bordered="false" :headStyle="{fontSize:'18px'}">
    <search-page-view
      :col="3"
      ref="pageList"
      :itemNames="['search_title','search_categoryId']"
      :columns="columns"
      :queryParams="queryParams"
      row-key="id"
      :leftSpace="30"
      :requestPromise="getListPromise"
    >
      <a-form-item slot="search_title" label="标题" v-bind="searchItemLayout">
        <a-input v-model="queryParams.title" placeholder="请输入"/>
      </a-form-item>
      <a-form-item slot="search_categoryId" label="分类名称" v-bind="searchItemLayout">
        <a-select
          allowClear
          v-model="queryParams.categoryId"
          placeholder="请选择"
          style="width: 100%">
          <a-select-option v-for="(item,index) in categoryList" :value="item.id" :key="index">
            {{ item.contentName }}
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item slot="operation">
        <a-button style="margin-left: 20px" type="primary" @click="createNewEvent(0)" icon="plus">新建</a-button>
      </a-form-item>
      <span slot="action" slot-scope="rowItem">
        <a @click="createNewEvent(rowItem.record.id)">编辑</a>
        <a-divider type="vertical"></a-divider>
        <a-popconfirm title="是否要删除本条数据？" @confirm="deleteEvent(rowItem.record.id)">
          <a>删除</a>
        </a-popconfirm>
        <a-divider type="vertical"></a-divider>
        <a v-if="rowItem.record.status==2" @click="updateStatus(rowItem.record.id,1)">显示</a>
        <a v-else @click="updateStatus(rowItem.record.id,2)">隐藏</a>
      </span>
    </search-page-view>
  </a-card>
</template>

<script>
import searchForm from '../../../../utils/mixins/searchFormMixins'

export default {
  name: 'ContentList',
  mixins: [searchForm],
  data() {
    return {
      queryParams: {},
      staffStatusList: [],
      columns: [
        {
          title: '内容ID',
          dataIndex: 'id',
          width: '80px'
        },
        {
          title: '标题',
          dataIndex: 'title'
        },
        {
          title: '分类名称',
          dataIndex: 'contentName',
          width: '140px'
        },
        {
          title: '作者',
          dataIndex: 'author',
          width: '120px'
        },
        {
          title: '内容时间',
          dataIndex: 'publicTime',
          width: '120px'
        },
        {
          title: '状态',
          dataIndex: 'statusStr',
          width: '80px'
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '180px',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ],
      merchantId: this.$store.getters.userInfo.merchantId,
      platformId: this.getPlatformConfig().platformId,
      categoryList: []
    }
  },
  mounted() {
    this.$store.commit('SET_MENU_HEAD_CONFIG', [
      { name: 'ContentList', title: '内容列表' },
      { name: 'ContentCategory', title: '内容分类' },
      { name: 'Introduction', title: '景区介绍' },
      { name: 'ScenicAreaDynamic', title: '景区动态' }
    ])
    this.getCategoryList()
  },
  methods: {
    deleteEvent(id) {
      let params = {
        merchantId: this.merchantId,
        platformId: this.platformId,
        id: id
      }
      this.getHttpServices().getServerApiService().post('advice/content/delete', params)
        .then(res => {
          this.$refs.pageList.refresh()
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    updateStatus(id, type) {
      let params = {
        status: type,
        merchantId: this.merchantId,
        platformId: this.platformId,
        id: id
      }
      this.getHttpServices().getServerApiService().post('advice/content/status', params)
        .then(res => {
          this.$refs.pageList.refresh()
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    getListPromise(params) {
      params.merchantId = this.merchantId
      params.platformId = this.platformId
      return this.getHttpServices().getServerApiService().post('advice/content/list', params)
    },
    getCategoryList() {
      let url = '/advice/category/' + this.merchantId + '/' + this.platformId
      this.getHttpServices().getServerApiService().post(url)
        .then(list => {
          this.categoryList = list
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    getStaffStatus() {
      this.getHttpServices().getUserService()
        .post('staff/v2/getStaffListRequestStatusItem')
        .then(list => {
          this.staffStatusList = list
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    createNewEvent(id) {
      let query = {}
      if (id) {
        query.id = id
      }
      this.openNewPage('AddContentList', query)
    }
  }
}
</script>

<style lang="less" scoped>

</style>